<template>
  <v-card class="ma-6">
    <v-card-title>
      <v-icon color="primary" class="mr-6">developer_board</v-icon>
      Cat Codes
      <div class="flex-grow-1"></div>
      <div class="flex-grow-1"></div>
      <v-text-field color="green" v-model="search" append-icon="search" label="Search by CatCode or Description"
        single-line hide-details></v-text-field>
    </v-card-title>

    <v-data-table class="row-pointer" dense :headers="headers" :options.sync="options" @click:row="rowClicked"
      :items="items" :server-items-length="totalItems" :footer-props="{
        itemsPerPageOptions: [10, 20, 100, 500, -1]
      }" :search="search" loading-text="Loading...please wait" :loading="loading">
      <template v-slot:top>
        <AddButton :onClick="addCatCode" />
      </template>
      <template v-slot:item.actions="{ item }">
        <v-row>
          <v-col>
            <v-btn icon @click="editClicked(item)">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </template>
    </v-data-table>
  </v-card>
</template>

<style lang="css" scoped>
.row-pointer>>>tbody tr :hover {
  cursor: pointer;
}
</style>

<script>
import { CatCodesService } from '../services/api/catCodes';
import { PartGroupsService } from '../services/api/partGroups';
import AddButton from '../components/data-table/AddButton.vue'
import _ from "lodash";

const apiCatCodes = new CatCodesService();
const apiPartGroups = new PartGroupsService();

export default {
  data() {
    return {
      totalItems: 0,
      items: [],
      loading: true,
      options: {
        itemsPerPage: 20,
      },

      search: '',

      headers: [
        { text: 'ID', value: 'id', hidden: true, align: ' d-none' },
        { text: 'CAT Code', value: 'catCodeString' },
        { text: 'Description', value: 'catCodeDesc' },
        { text: 'Days between scans', value: 'daysBetweenScans', align: 'center', width: 100, divider: true },
        { text: 'Marketplace Settings', value: 'marketplaceSettings', align: 'center', width: 100, divider: true },
        { text: 'Refined Min Qty', value: 'refinedMinQty', align: 'center', width: 100 },
        { text: 'Quantity Cap', value: 'qtyCap', align: 'center', width: 100 },
        { text: 'Min Qty To Scan', value: 'minQtyToScan', align: 'center', width: 100 },
        { text: 'Edit', value: 'actions', align: 'center', width: 100, sortable: false },
      ],
    }
  },

  watch: {
    options: {
      handler() {
        this.loadItems()
      },
      deep: true,
    },
    // Watch for changes to the search text.
    search: function () {
      this.debouncedloadItems();
    }
  },

  created: function () {
    this.debouncedloadItems = _.debounce(this.loadItems, 500);
  },

  methods: {
    loadItems() {
      this.loading = true
      return new Promise((resolve, reject) => {
        this.getCatCodes();
      })
    },

    getCatCodes() {
      this.loading = true;

      // Clear our list so the loading text will be shown.
      this.items = [];

      // Set up our search, sort, and paging parameters
      const search = {
        searchText: this.search,

        // If there's a sortBy field set, then use it; otherwise use a reasonable default.
        sortOrderField: this.options.sortBy.length == 1 ? this.options.sortBy[0] : "CatCodeString",
        // If there's no sortDesc defined, sort by desc.  Otherwise sort by the value.
        sortDirection: this.options.sortDesc.length == 0 ? "desc" : (this.options.sortDesc[0] ? "desc" : "asc"),
        itemsPerPage: this.options.itemsPerPage,
        itemsToSkip: this.options.itemsPerPage * (this.options.page - 1),

      }

      // Get the list of items from the API.
      apiCatCodes.getCatCodes(search).then((data) => {
        for (let i = 0; i < data.items.length; i++) {
          if (data.items[i].marketplaceSettings?.length > 0) {
            for (let j = 0; j < data.items[i].marketplaceSettings.length; j++) {
              const name = data.items[i].marketplaceSettings[j].marketplaceName;
              const daysBetweenScans = data.items[i].marketplaceSettings[j].daysBetweenScans;
              data.items[i].marketplaceSettings[j] = `${name}: ${daysBetweenScans} days between scans`;
            }
          }
        }

        this.items = data.items
        this.totalItems = data.totalItemCount;
      });

      this.loading = false;
    },

    // When a row is clicked, go to the detail page.
    rowClicked(item) {
      //this.$router.push({ name: "CatCodeEdit", params: { id : item.id } });
      this.$router.push({ name: "CatCode", params: { catCodeString: item.catCodeString } });
    },

    editClicked(item) {
      this.$router.push({ name: "CatCodeEdit", params: { id: item.id } });
    },

    async addCatCode() {
      const getPartGroupsResult = await apiPartGroups.getPartGroups();
      console.log(getPartGroupsResult);
      if (!getPartGroupsResult.items.length) {
        alert("You must have at least one Part Group before you can add a Cat Code.");
        return;
      }

      const catCodeString = prompt("Enter the new cat code string");
      if (catCodeString == null || catCodeString.trim() == "") {
          return;
      }
      const newCatCode = await apiCatCodes.saveCatCode({
          catCodeString: catCodeString.trim(),
          PartGroupID: getPartGroupsResult.items[0].id,
          wordsToInclude: null,
          wordsToExclude: null,
          daysBetweenScans: 7,
          refinedMinQty: 5,
          qtyCap: 100,
          minQtyToScan: 1,
      });
      await this.$router.push({ name: "CatCodeEdit", params: { id: newCatCode.id } });
    },
  },
  components: { AddButton }
}
</script>